// Home.js
import React, { useState } from 'react';
import { useMediaQuery } from '@mui/material';
import TopBar from './TopBar';
import SideBar from './SideBar';
import { Outlet } from 'react-router-dom';
import MobileSideBar from './MobileSideBar';

const Home = () => {
    const isMobileView = useMediaQuery('(max-width: 600px)'); // Check if it's a mobile view

    const [sidebarMobileOpen, setSidebarMobileOpen] = useState(!isMobileView); // Default sidebar open based on mobile view
    const [sidebarOpen, setSidebarOpen] = useState(!isMobileView); // Default sidebar open based on mobile view

    const handleMenuToggle = () => {
        if (isMobileView) {
            setSidebarMobileOpen(!sidebarMobileOpen);
        }
        else {
            setSidebarOpen(!sidebarOpen);
        }
    };

    const handleSidebarMobileClose = () => {
        if (isMobileView) {
            setSidebarMobileOpen(false);
        }
    };

    const handleSidebarClose = () => {
        setSidebarOpen(false);
    };

    return (
        <div style={{ backgroundColor: '#cfcfcf !important' }}>
            <TopBar onMenuToggle={handleMenuToggle} onClose={handleSidebarMobileClose} />
            {/* Conditionally render the sidebar based on screen size */}
            {isMobileView ? (
                <MobileSideBar open={sidebarMobileOpen} onClose={handleSidebarMobileClose} />
            ) : (
                <SideBar open={sidebarOpen} onClose={handleSidebarClose} />
            )}
            <div style={{ marginLeft: sidebarOpen && !isMobileView ? '180px' : isMobileView ? '10px' : "75px" }}>
                <div>
                    <main
                        id="main-element"
                        style={{
                            flexGrow: 1,
                            minHeight: 'calc(100vh - 90px)',
                            height: 'calc(100vh - 90px)',
                            marginTop: '15px',
                            overflow: 'auto',
                            maxWidth: '100%',
                        }}
                    >
                        <Outlet />
                    </main>
                </div>
            </div>
        </div>
    );
};

export default Home;
